export default __webpack_public_path__ + "188db53ccca7ef36ccf70f52bd988cad.png";